(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.ListeningSentiments = exportFn();
        });

    }

    function exportFn() {
        return {
            Negative: 'Negative',
            Neutral: 'Neutral',
            Positive: 'Positive'
        };
    }
})();
